import { cx } from '@emotion/css';
import type { ComponentProps, FC } from 'react';

export interface ODSModalFooterProps extends ComponentProps<'div'> {
  /** Change button alignment */
  align?: 'start' | 'center' | 'end' | 'between';
}

export const ODSModalFooter: FC<ODSModalFooterProps> = ({
  align = 'end',
  children,
  className,
  ...componentProps
}) => {
  return (
    <div
      data-testid="modal-footer"
      className={cx(
        className,
        'ods-modal-footer d-flex border-top gap-2 p-3',
        `justify-content-${align}`
      )}
      {...componentProps}
    >
      {children}
    </div>
  );
};
